import React from 'react';
import Footer from '../../components/Footer';

function ContactPage() {
  return (
    <main className="contact-page">
      <div className="doc-container">
        <div className="contact-hero">
          <span className="contact-eyebrow">Say hello</span>
          <h1 className="contact-title">
            We'd love to
            <br />
            <em>hear from you.</em>
          </h1>
        </div>

        <div className="contact-body">
          <p>
            Have a concern, a suggestion, or just want to say hi? Drop us an email — we read every
            message.
          </p>
          <div className="contact-sign">
            <a href="mailto:getholdonapp@gmail.com" className="btn-contact">
              getholdonapp@gmail.com
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default ContactPage;
